<google-map
    maxZoom="17"
    mapId="storytelling-map"
    class="st-map-view-google-map"
    [height]="height()"
    [width]="width()"
    [zoom]="mapZoom()"
    [options]="options()"
    (mapInitialized)="mapInit()"
    (zoomChanged)="updateCurrentZoom()"
    (centerChanged)="updateCurrentCenter()"
    (boundsChanged)="updateCurrentBounds()">
    <map-marker-clusterer
        #markerCluster
        [imagePath]="markerImgPath"
        [zoomOnClick]="!mapLockLocation()"
        [maxZoom]="currentClusterMaxZoom()">
        @for (marker of markerData(); track marker) {
            <map-marker
                ref-mapMarker
                class="map-marker"
                [clickable]="true"
                [position]="marker.position"
                [icon]="marker.iconUrl"
                [label]="marker.labelOptions ? marker.labelOptions : ''"
                (mapClick)="markerClick(marker)" />
        }
        <ng-container>
            <map-info-window>
                <ng-template
                    let-item
                    ngFor
                    [ngForOf]="currentOpenedItems()">
                    <ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: item }" />
                </ng-template>
                <ng-container *ngTemplateOutlet="footerTemplate()" />
            </map-info-window>
        </ng-container>
    </map-marker-clusterer>
    @if (!mapLockLocation()) {
        <button
            class="st-map-view-google-map__button__add buttons"
            (click)="zoomIn()">
            <mat-icon>add</mat-icon>
        </button>
        <button
            class="st-map-view-google-map__button__remove buttons"
            (click)="zoomOut()">
            <mat-icon>remove</mat-icon>
        </button>
    }
</google-map>
